import { render, staticRenderFns } from "./embedder.vue?vue&type=template&id=d122946e&scoped=true&"
import script from "./embedder.vue?vue&type=script&lang=js&"
export * from "./embedder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d122946e",
  null
  
)

export default component.exports